module.exports = {
    check_email: '請輸入正確的郵箱格式',
    check_phone: '請輸入正確的手機號格式',
    check_password: '至少8位字符,包含1個數字,至少1個大寫字符',
    not_character: '不支持特殊字符',
    decimal_two: '最多隻能輸入小數點後兩位',
    be_about_to_pop: '即將上線，敬請期待',
    withdrawal_address_incorrect: '提現地址不正確 !',
    Minimum_cash_out_amount: '最小提現額度為50 USDT'
}
